import * as T from '../constants/types';
import { Auth } from 'aws-amplify';
import { throwError } from './throwNotification';
import { setLayersAccordingToUserGroup } from './setLayersAccordingToUserGroup';
import { parseSettingsAttribute, readCachedUserSettings, writeCachedUserSettings } from '../utils/userSettings';

export const requestLoggedUserInfo = () => async dispatch => {
    try {
        // bypassCache обязателен: без него Amplify отдаёт атрибуты из своей локальной
        // копии userData и настройки, изменённые в другом браузере, сюда не доедут
        const { attributes, signInUserSession } = await Auth.currentAuthenticatedUser({ bypassCache: true });
        const { email } = attributes;
        const groups = signInUserSession.accessToken.payload['cognito:groups'] || [];
        // Настройки берём из тех же атрибутов — отдельный запрос не нужен.
        // Пришли из Cognito — они и есть истина, кэш переписываем под них;
        // атрибут пуст (первый вход, ещё ничего не настраивал) — остаёмся на кэше
        const settingsFromCognito = parseSettingsAttribute(attributes);
        if (settingsFromCognito) {
            writeCachedUserSettings(settingsFromCognito);
        }
        const userSettings = settingsFromCognito || readCachedUserSettings();
        dispatch({ type: T.REQUEST_LOGGED_USER_INFO + T.SUCCESS, payload: { email, groups, userSettings } });
        dispatch(setLayersAccordingToUserGroup(groups));
    } catch (error) {
        dispatch(throwError(error, T.REQUEST_LOGGED_USER_INFO + T.ERROR));
    }
};
